module.exports = "/assets/scripts/apps/overlays/1.11/img/chevron-right.svg";